import { AUD_DENOMINATIONS, denominationLabel } from '../../../utils/counterCash';
import type { CashBreakdown } from '../../../types/nurseryCounter';

/**
 * Count a till by notes and coins. The total is worked out as the boxes are
 * filled, and the count itself is kept with the record, so a later question
 * about the till can be answered from what was counted, not just the sum.
 */

export interface CashCountProps {
  idPrefix: string;
  value: CashBreakdown;
  onChange: (next: CashBreakdown) => void;
  denominations?: number[];
  disabled?: boolean;
}

export function CashCount({ idPrefix, value, onChange, denominations = AUD_DENOMINATIONS, disabled }: CashCountProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
      {denominations.map((cents) => {
        const id = `${idPrefix}-${cents}`;
        const count = value[String(cents)] ?? 0;
        return (
          <div key={cents} className="flex items-center gap-2 min-w-0">
            <label htmlFor={id} className="w-10 shrink-0 text-sm font-medium text-neutral-700 text-right">
              {denominationLabel(cents)}
            </label>
            <span className="text-neutral-400 text-sm" aria-hidden>×</span>
            <input
              id={id}
              type="text"
              inputMode="numeric"
              disabled={disabled}
              value={count ? String(count) : ''}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, '').slice(0, 5);
                onChange({ ...value, [String(cents)]: digits ? Number(digits) : 0 });
              }}
              aria-label={`Number of ${denominationLabel(cents)}`}
              className="min-w-0 w-full border border-neutral-300 rounded-lg px-2 py-1.5 text-sm text-right"
            />
          </div>
        );
      })}
    </div>
  );
}
